import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormArray, FormBuilder, Validators } from '@angular/forms';
import { cloneDeep } from 'lodash-es';
import { uniqueTextValidator } from '../../../../../../shared/custom-validators/uniqueText.validator';
import { Task } from '../../../domain/models/fcp.model';
const ZERO_LENGTH = 0;

@Component({
    selector: 'tasks-form',
    templateUrl: './annualreport-checklist.component.html',
    styleUrls: ['./annualreport-checklist.component.scss'],
})
export class AnnualreportChecklistComponent {
    public tasks: FormArray;
    private _tasks: Task[] = [];

    @Input()
    set checkListTasks(value: Task[]) {
        if (value != null) {
            const tasks = cloneDeep(value);
            tasks.forEach((task) => this.addTask(task));
            this._tasks = tasks;
        } else {
            this.addTask();
        }
    }

    get checkListTasks(): Task[] {
        return this._tasks;
    }

    @Output() onSubmitChecklistForm = new EventEmitter<Task[]>();
    @Output() onCancelCheckList = new EventEmitter<void>();
    @Output() markTaskToRemove = new EventEmitter<string>();

    constructor(private readonly fb: FormBuilder) {
        this.tasks = this.fb.array([], uniqueTextValidator());
    }
    addTask(task: Partial<Task> = {}): void {
        this.tasks.push(
            this.fb.group({
                id: [task.id || null],
                text: [{ value: task.text || '', disabled: task.isDone || false }, Validators.required],
                isSealed: [task.isSealed || false],
                isDone: [task.isDone || false],
            }),
        );
    }

    removeTask(index: number): void {
        const task = this.tasks.at(index).getRawValue();
        this.tasks.removeAt(index);
        this.markTaskToRemove.emit(task.text);
        this._tasks.splice(index, 1);
    }

    onSubmit(): void {
        if (this.tasks.length > ZERO_LENGTH) {
            this.onSubmitChecklistForm.emit(this.tasks.getRawValue());
        }
    }

    onCancel(): void {
        this.onCancelCheckList.emit();
    }
}
